import ImgContainer from '@/components/Vcms/ImgContainer';
import parse from 'html-react-parser';

export const convertStrToComp = (template: any) => parse(template || '', {
  replace: (props: any) => {
    const { name, type, attribs } = props;
    if (type === 'tag' && name === 'img') {
      return (
        <ImgContainer
          {...(attribs || {})}
          height={attribs.height || 300}
          width={attribs.width || 1000}
          sizes="100vw"
        />
      );
    }
    return null;
  },
});
